/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable quotes */
import { CurrencyPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { TableExpansionTemplate } from 'src/app/@amiga-pyme/table-expansion/templates/table-expansion.template';
import { IStock, STOCK_TTL_ES } from '../stock.interface';
import { StockService } from '../stock.service';

@Component({
  selector: 'pg-stock',
  templateUrl: './stock.component.html',
  providers: [CurrencyPipe, MessageService]
})
export class StockComponent extends TableExpansionTemplate {
  sidebar = {
    price: {
      open: false,
      data: null
    },
    quantity: {
      open: false,
      data: null
    }
  };
  confirmSettings = {};
  format = {};
  nameFormat = '';
  nameSubFormat = '';
  displayModal = false;
  newMessage = '';
  withIgv = 0;
  stockSubFormat = 0;
  constructor(
    private serviceBase: StockService,
    private currencyPipe: CurrencyPipe,
    private serviceStock: StockService,
    private messageService: MessageService
  ) {
    super(STOCK_TTL_ES, serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: STOCK_TTL_ES,
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Código', field: 'productCode' },
        { header: 'Nombre', field: 'productName' },
        { header: 'Concentración', field: 'productRegulatedConcentration' },
        {
          header: 'Tipo de Presentación',
          field: 'productRegulatedPresentation'
        },
        { header: 'Laboratorio', field: 'productRegulatedLaboratory' },
        { header: 'Expiración', field: 'expAt', pipe: 'Date' },
        { header: 'Lote', field: 'lot' },
        { header: 'IGV', field: 'withIgv', pipe: 'Boolean' }
      ],
      child: {
        columnPatent: {
          title: 'productName',
          data: 'format'
        }
      }
    };
    this.table.actions = [
      {
        name: 'updateIGV',
        icon: 'pi pi-percentage',
        class: 'p-button-rounded p-button-info',
        pTooltip: 'Modificar IGV'
      }
    ];

    this.tableChild.settings = {
      title: '',
      columns: [
        { header: 'F.V.', field: 'format' },
        { header: 'S.F.V', field: 'subFormat' },
        { header: 'Cnt.S.F.V', field: 'quantitySubFormat' },
        { header: 'Stock', field: 'stock' },
        { header: 'P.C.', field: 'purchasePrice', pipe: 'Currency' },
        { header: '% Ganancia', field: 'profitMargin', pipe: 'Percent' },
        { header: 'P.V.', field: 'precio', pipe: 'Currency' }
      ],
      filterColumns: false,
      exportData: false
    };

    this.tableChild.actions = [
      {
        name: 'price',
        icon: 'pi pi-dollar',
        class: 'p-button-rounded p-button-success',
        pTooltip: 'Ajustar Precio'
      },
      {
        name: 'quantity',
        icon: 'pi pi-box',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ajustar Stock'
      },
      {
        name: 'open',
        icon: 'pi pi-inbox',
        class: 'p-button-rounded p-button-warning',
        pTooltip: 'Abrir Presentación'
      }
    ];

    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IStock[]) => {
        this.table.data = data;
        // this.table.data.map((product) => {
        //   Object.keys(product.format).forEach((key) => {
        //     product.format[key]['precio'] = this.currencyPipe.transform(
        //       product.format[key]['precio'],
        //       'PEN'
        //     );
        //     product.format[key]['purchasePrice'] = this.currencyPipe.transform(
        //       product.format[key]['purchasePrice'],
        //       'PEN'
        //     );
        //   });
        // });
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }

  onReciveAction(event: IEventAction): void {
    const { action, data } = event;
    if (action === 'updateIGV') {
      if (data.withIgv) {
        this.newMessage = 'Cambiar estado de IGV';
      } else {
        this.newMessage = 'Incluir IGV';
      }
      this.confirmSettings = {
        message: this.newMessage,
        action: 'updateIGV',
        data
      };
    }
  }

  onReciveActionChild(event: IEventAction): void {
    const { action, data } = event;
    if (action === 'price') {
      this.handleClickUpdatePrice(data);
    }
    if (action === 'quantity') {
      this.handleClickUpdateStock(data);
    }
    if (action === 'open') {
      const { action, data } = event;
      this.confirmSettings = {
        message: 'Abrir presentacion de venta',
        action: 'open',
        data
      };
    }
  }

  onCloseSideBarPrice() {
    this.sidebar.price.open = false;
  }

  onCloseSideBarQuantity() {
    this.sidebar.quantity.open = false;
  }

  handleClickUpdatePrice(data: any) {
    this.sidebar.price.data = data;
    this.sidebar.price.open = true;
  }

  handleClickUpdateStock(data: any) {
    this.sidebar.quantity.data = data;
    this.sidebar.quantity.open = true;
  }
  async actionConfirmed(event) {
    const { action, data } = event;
    if (action == 'open') {
      const childInformation = data.selectedChild;
      const parentInformation = data.selectedParent;
      const quantitySubFormat = childInformation.quantitySubFormat;
      if (quantitySubFormat == null) {
        this.messageService.add({
          severity: 'warn',
          summary: 'No hay cantidad de subformato de venta (Cnt.S.F.V)',
          detail:
            'Para descomprimir un producto se debe especificar la cantidad en el campo  (Cnt.S.F.V) '
        });
        return;
      }
      const stockFormat = childInformation.stock;
      this.nameFormat = childInformation.format;
      this.nameSubFormat = childInformation.subFormat;
      if (this.nameSubFormat != null && stockFormat > 0) {
        const stockSubFormat =
          parentInformation.format[this.nameSubFormat].stock == null
            ? 0
            : parentInformation.format[this.nameSubFormat].stock;
        const newstockFormat = stockFormat - 1;
        const newstockSubFormat = stockSubFormat + quantitySubFormat;

        this.format = parentInformation.format;
        const newFormat = this.format;
        newFormat[this.nameFormat].stock = newstockFormat;
        newFormat[this.nameSubFormat].stock = newstockSubFormat;

        const id = parentInformation.id;
        this.message = { message: 'Modificando stock de venta' };
        const fieldsToUpdate = {
          format: newFormat
        };
        this.message = await this.serviceStock.update(id, fieldsToUpdate);
      } else {
        this.displayModal = true;
      }
    }
    if (action == 'updateIGV') {
      const id = data.id;
      if (data.withIgv) {
        this.withIgv = 0;
      } else {
        this.withIgv = 1;
      }
      const fieldsToUpdate = {
        withIgv: this.withIgv
      };
      this.message = await this.serviceStock.update(id, fieldsToUpdate);
    }
  }
}
